export const mockDataPromoteCandidate = {
  success: true,
  mergeID: 12345,

  // status: "merged",

  // status: "elevated_priv",
  // pendingMergeApprover: {
  //   userID: 123,
  //   photoURL: "//d6iyrqjd26xke.cloudfront.net/profileforest2/profile.jpg",
  //   displayName: "Larry Summers",
  // },

  // status: "conflicts",

  status: "unmergable",
  unmergableMessage:
    "One or both of these users are already part of an active pending merge.",
};
